
// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import PageLayout from "examples/LayoutContainers/PageLayout";

// Authentication layout components
import Fade from "@mui/material/Fade";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import {ToggleButton, ToggleButtonGroup} from "@mui/lab";
import {setLanguage} from "../../../../actions";
import {FormControl, Select} from "@mui/material";
import MDButton from "../../../../components/MDButton";
import LanguageIcon from "@mui/icons-material/Language";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import React, {useState} from "react";

function CoverLayout({ coverHeight, image, children }) {
  const languageList = [
    {
      id: 1,
      label: 'En',
      lang:'en',
      value: 1
    },
    {
      id: 2,
      label: '中文',
      lang:'zh',
      value: 2
    },
    {
      id: 3,
      label: 'Fr',
      lang:'fr',
      value: 3
    },
  ]
  const language = useSelector(state => state?.common?.language,(prev, next) => prev === next)
  const dispatch = useDispatch()
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm')); // 检查是否是xs断点

  const handleToggle = (event, lang) => {
    dispatch(setLanguage(lang));
    i18n.changeLanguage(lang)
  };

  const handleLanguageSelectChange = (event) => {
    dispatch(setLanguage(languageList.find((lang) => lang.value === event.target.value )?.lang));
    i18n.changeLanguage(languageList.find((lang) => lang.value === event.target.value )?.lang);
    setLanguageSelect(event.target.value);
  };
  const handleLanguageSelectClose = () => {
    setOpenLanguageSelect(false);
  };

  const handleLanguageSelectOpen = () => {
    setOpenLanguageSelect(true);
  };

  const positionStyle = isXs
      ? { top: '5%', right: 'none' }
      : { top: '5%', right: '5%', bottom: 'none' };

  const [languageSelect ,setLanguageSelect] = useState(languageList.find((lang)=>lang.lang === i18n.language).value);
  const [openLanguageSelect,setOpenLanguageSelect] = useState(false);

  return (
    <PageLayout
        sx={{overflow: 'hidden'}}    
    >
        <MDBox
        width="calc(100% - 2rem)"
        minHeight={coverHeight}
        borderRadius="xl"
        mx={2}
        my={2}
        pt={6}
        pb={28}
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            image &&
            `${linearGradient(
              rgba(gradients.dark.main, 0.4),
              rgba(gradients.dark.state, 0.4)
            )}, url(${image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <MDBox mt={{ xs: -20, lg: -18 }} px={1} width="calc(100% - 2rem)">
        <Grid container spacing={1} justifyContent="center">
          <Grid item xs={11} sm={9} md={5} lg={4} xl={3} >

                  {children}
              {process.env.REACT_APP_LANG_TRANSLATION === 'true' &&
              // <ToggleButtonGroup
              //       color="primary"
              //       value={language}
              //       exclusive
              //       onChange={handleToggle}
              //       aria-label="Platform"
              //       sx={{
              //         position:'fixed',
              //         ...positionStyle,// 在 md 断点为 5%，在 xs 断点为 none
              //         zIndex:'9999',
              //         borderRadius:5,
              //         background:'white',
              //         padding:0,
              //         '& .MuiToggleButton-root': {
              //           fontSize: { xs: '0.875rem', md: '0.75rem' },  // 调整字体大小，xs 时较大模拟 'medium' 效果
              //           padding: { xs: '8px 0px', md: '6px 0px' },
              //           width: 40,// 调整内边距，xs 时较大模拟 'medium' 效果
              //         },
              //         '& .Mui-selected':{
              //           color:'#3f50b5',
              //           background:'rgba(63,80,181,0.3)'
              //         }
              //       }}
              //   >
              //     <ToggleButton disableRipple value="en" sx={{border:'none',fontWeight:'bold'}}>
              //         {/*<span className="fi fi-ca"></span> */}
              //         <div style={{paddingLeft:'5px'}}>{language === 'zh' ? '英' : 'EN'}</div></ToggleButton>
              //     <ToggleButton disableRipple value="zh" sx={{border:'none',fontWeight:'bold'}}>
              //         {/*<span className="fi fi-cn"></span>*/}
              //         <div style={{paddingLeft:'5px'}}>{language === 'en' ? 'ZH' : '中'}</div>
              //     </ToggleButton>
              //   </ToggleButtonGroup>

                  <IconButton
                      size="small"
                      disableRipple
                      color="inherit"
                      disableFocusRipple
                      // sx={navbarIconButton}
                      sx={{
                        position:'fixed',
                        ...positionStyle,// 在 md 断点为 5%，在 xs 断点为 none
                        zIndex:'9999',
                        borderRadius:5,
                        background:'white',
                        padding:0,
                        '& .MuiToggleButton-root': {
                          fontSize: { xs: '0.875rem', md: '0.75rem' },  // 调整字体大小，xs 时较大模拟 'medium' 效果
                          padding: { xs: '8px 0px', md: '6px 0px' },
                          width: 40,// 调整内边距，xs 时较大模拟 'medium' 效果
                        },
                        '& .Mui-selected':{
                          color:'#3f50b5',
                          background:'rgba(63,80,181,0.3)'
                        }
                      }}
                  >
                    <FormControl fullWidth>
                      <Select
                          sx={{
                            boxShadow: "none",
                            ".MuiOutlinedInput-notchedOutline": { border: 0 },
                            "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                {
                                  border: 0,
                                },
                            "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  border: 0,
                                },
                          }}
                          open={openLanguageSelect}
                          value={languageSelect}
                          onChange={handleLanguageSelectChange}
                          onClose={handleLanguageSelectClose}
                          onOpen={handleLanguageSelectOpen}
                          renderValue={(value)=>{
                            return(
                                <MDButton sx={{padding:"4px"}} variant={'text'} color="info" startIcon={<LanguageIcon/>} onClick={handleLanguageSelectOpen}>
                                  {languageList.find(v=>v.value === value)?.label || ""}
                                </MDButton>
                            )
                          }}
                      >
                        <MenuItem value={1}>English</MenuItem>
                        <MenuItem value={2}>中文 (Chinese)</MenuItem>
                        <MenuItem value={3}>Français (Canada)</MenuItem>
                      </Select>
                    </FormControl>
                  </IconButton>

              }

          </Grid>
        </Grid>
      </MDBox>
    </PageLayout>
  );
}

// Setting default props for the CoverLayout
CoverLayout.defaultProps = {
  coverHeight: "35vh",
};

// Typechecking props for the CoverLayout
CoverLayout.propTypes = {
  coverHeight: PropTypes.string,
  image: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default CoverLayout;
